import { createContext, useContext } from 'react';

export type DubbingLanguageContextType = {
  loading?: boolean;
  dubbingLanguageCodes?: Array<string> | null;
  userLanguageCode?: string | null;
};

const DubbingLanguageContext = createContext<DubbingLanguageContextType | undefined>(undefined);

export const useDubbingLanguage = () => {
  return useContext(DubbingLanguageContext) || {};
};

export default DubbingLanguageContext;
